import { MapContainer, Marker, LayersControl, ScaleControl, Circle } from 'react-leaflet';
import * as L from "leaflet";
import VectorBasemapLayer from "react-esri-leaflet/plugins/VectorBasemapLayer";
import { renderToStaticMarkup } from 'react-dom/server';
import 'leaflet/dist/leaflet.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import { faMapMarker, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';

import MapLayers from './MapLayers';

const TowersMapContainer = ({ setMap, data, searchMarker, highlightMarker, towerFilters }) => {
    const theme = useTheme();
    const onlySmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const position = [40.4977, -121.4207];
    const { BaseLayer } = LayersControl;

    const SearchIcon = L.divIcon({
        html: renderToStaticMarkup(<FontAwesomeIcon icon={faMapMarkerAlt} className="iconPOI" />),
        iconAnchor: [10, 28] // set to [1/2 width, full height];
    });

    const HighlightIcon = L.divIcon({
        html: renderToStaticMarkup(<FontAwesomeIcon icon={faMapMarker} className="iconTower iconGlow" />),
        iconAnchor: [9, 24] // set to [1/2 width, full height];
    });

    return (
        <>
            <MapContainer
                center={position}
                zoom={5}
                maxZoom={18}
                scrollWheelZoom={true}
                ref={setMap}>
                <ScaleControl position="bottomleft" />
                <LayersControl
                    collapsed={onlySmallScreen ? true : false}
                >

                    {/* <BaseLayer name="Open Street Map">
                    <VectorBasemapLayer name="OSM:Standard" token={'AAPK4809ddeec7e641c0a21edf081e29498aAJoH7Xr1yGz3Ct_fbA89kNOSQ1_rt_pqttgNVDEN0tN8fshiBEPXsP7vDvMV0K5B'} />
                    </BaseLayer> */}

                    <BaseLayer checked name="Street Map">
                        <VectorBasemapLayer name="ArcGIS:Streets" token={'AAPK4809ddeec7e641c0a21edf081e29498aAJoH7Xr1yGz3Ct_fbA89kNOSQ1_rt_pqttgNVDEN0tN8fshiBEPXsP7vDvMV0K5B'} />
                    </BaseLayer>

                    <BaseLayer name="Aerial Imagery">
                        <VectorBasemapLayer name="ArcGIS:Imagery" token={'AAPK4809ddeec7e641c0a21edf081e29498aAJoH7Xr1yGz3Ct_fbA89kNOSQ1_rt_pqttgNVDEN0tN8fshiBEPXsP7vDvMV0K5B'} />
                    </BaseLayer>

                </LayersControl>

                {highlightMarker !== null &&
                    <Marker position={highlightMarker} icon={HighlightIcon} zIndexOffset={200}></Marker>
                    // <CircleMarker center={highlightMarker} radius={12} color={'yellow'} opacity={0.9} fillOpacity={0}/>
                }
                {searchMarker !== null &&
                    <Marker position={searchMarker} icon={SearchIcon} zIndexOffset={100}>
                        {/* <CircleMarker className='circleMark' center={searchMarker} radius={3} color={'green'} opacity={0.9} fillOpacity={1}/> */}
                    </Marker>
                }
                {searchMarker !== null && towerFilters.distance !== null &&
                    <Circle center={searchMarker} radius={(Number(towerFilters.distance) * Number(1609.34))} pathOptions={{ color: '#283891', weight: 1, fill: false }} />
                }
                <MapLayers data={data} />

            </MapContainer>
        </>
    );
}

export default TowersMapContainer;